
import PreprText from './Prepr/Text'

const CUSTOM_ELEMENTS = {
  'c476befe-c50f-400a-830a-949941ec06e8': 'Button',
  '580c0d29-fee3-42ac-85c8-04f6f9688842': 'CallToAction',
  '90dd730a-52d1-43b7-81d1-d1130fcb4458': 'Donation',
  'e3d181d4-02b7-4995-983d-a670504f62db': 'Datawrapper',
  '6f3afd2c-00ae-4b2b-8cb5-76cb762412b2': 'FlocklerEmbed',
  '88616f4b-45af-433b-92e7-034c1ba6f953': 'Frame',
  'f6bd71de-ce9e-4ffd-b64e-ce1cd5fabc65': 'Giphy',
  'cdf51f29-69fc-4fcc-8a6f-64141880b5ba': 'NewsletterSubscribe',
  'b93439d6-3374-4681-8456-cd8b2e57b505': 'NpoMedia',
  '76eee917-812e-4a4f-8dca-b4d4881eb53d': 'Playlist',
  '491c6ed2-de29-43c7-9d32-84bfd7de7769': 'Poll',
  '21dbbea9-2e1c-42b2-833c-d9266602f434': 'Qualifio',
  '844e5665-c33c-4845-964d-b34134bcefbd': 'Quote',
  '1acab3da-030c-4326-9e38-4097a3518d05': 'SmartList',
  'b3b746d2-1bec-48e4-b012-9fabe7142c85': 'ReferenceToPublication',
  'c1d20995-45d5-4e51-bfe1-84786cb07141': 'Typeform',
}

export default {
  name: 'EoRenderer',
  components: {
    PreprAsset: () => import('./Prepr/Asset'),
    PreprButton: () => import('./Prepr/Button'),
    PreprCardItem: () => import('./Prepr/CardItem'),
    PreprDatawrapper: () => import('./Prepr/Datawrapper'),
    PreprCallToAction: () => import('./Prepr/CallToAction'),
    PreprDonation: () => import('./Prepr/Donation'),
    PreprFacebookPost: () => import('./Prepr/FacebookPost'),
    PreprFlocklerEmbed: () => import('./Prepr/FlocklerEmbed'),
    PreprFrame: () => import('./Prepr/Frame'),
    PreprGiphy: () => import('./Prepr/Giphy'),
    PreprInstagramPost: () => import('./Prepr/InstagramPost'),
    PreprNewsletterSubscribe: () => import('./Prepr/NewsletterSubscribe'),
    PreprNpoMedia: () => import('./Prepr/NpoMedia'),
    PreprPhoto: () => import('./Prepr/Photo'),
    PreprPlaylist: () => import('./Prepr/Playlist'),
    PreprPoll: () => import('./Prepr/Poll'),
    PreprQualifio: () => import('./Prepr/Qualifio'),
    PreprQuote: () => import('./Prepr/Quote'),
    PreprReferenceToPublication: () => import('./Prepr/ReferenceToPublication'),
    PreprSmartList: () => import('./Prepr/SmartList'),
    PreprSoundCloudPost: () => import('./Prepr/SoundCloudPost'),
    PreprSpotifyPlaylist: () => import('./Prepr/SpotifyPlaylist'),
    PreprText, // cannot be async, because it can have multiple root nodes, which breaks SSR
    PreprTikTokPost: () => import('./Prepr/TikTokPost'),
    PreprTwitterPost: () => import('./Prepr/TwitterPost'),
    PreprTypeform: () => import('./Prepr/Typeform'),
    PreprVimeoPost: () => import('./Prepr/VimeoPost'),
    PreprYouTubePost: () => import('./Prepr/YouTubePost'),
  },
  props: {
    /**
     * Array of objects as provided by Prepr's 'ElementBox' (their drag-and-drop editor)
     */
    preprItems: {
      type: [Array, Object],
      default: null,
    },
    /**
     * Overwrite or add props to the rendered EO components
     */
    preprOverwrite: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Array of allowed cookies by user: (necessary) (analytics) (recommendations) (social)
     */
    allowedCookies: {
      type: Array,
      validator: prop => {
        if (!prop || !prop.length) return true
        if (typeof prop === 'string') return ['necessary', 'analytics', 'recommendations', 'social'].includes(prop)
        if (Array.isArray(prop)) return prop.some(p => ['necessary', 'analytics', 'recommendations', 'social'].includes(p))
        return false
      },
      default: null,
    },
    /**
     * Tracking: AT Internet site id
     */
    atSiteId: {
      type: [Number, String],
      default: null,
    },
    /**
     * Tracking: AT Internet user id
     */
    atUserId: {
      type: String,
      default: null,
    },
    /**
     * Tracking: AT Internet user id cookie duration
     */
    atUserIdDuration: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    overwrites () {
      const overwritesGlobal = this.$library.EoRenderer || {}
      const overwritesLocal = this.preprOverwrite || {}
      return {
        ...overwritesGlobal,
        ...overwritesGlobal.PublicationElement,
        ...overwritesLocal,
        ...overwritesLocal.PublicationElement,
      }
    },
    renderablePreprItems () {
      /**
       * Returns only the items for which a component is available
       */
      if (!this.preprItems || !this.preprItems.length) return null
      let items = this.preprItems
      if (typeof items === 'object') {
        items = Object.values(items)
      }

      // Flatten the custom elements we created in Prepr
      items = items.map((item) => {
        if (item.label === 'PublicationElement') {
          return {
            ...item.items, // all fields of the element
            ...(item.items?.id && {idData: item.items.id}), // copy for when element has a field 'id'
            ...(item.items?.label && {labelData: item.items.label}), // copy for when element has a field 'id'
            id: item.id, // id of the element
            label: CUSTOM_ELEMENTS[item.id], // name of the element
          }
        }
        return item
      })

      // Only return elements we created a component for
      return items.filter(item => this.$options.components[`Prepr${item.label}`])
    },
  },
}
